import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
// import {
//   CustomQuery
// } from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useArtcleCatList = (cid: string): any => {
  const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useArtcleCatListcontext---------", context.useApiError);
  // Shared ref holding the response from the API
  const result = sharedRef(null, `useArtcleCatList-${cid}`);
  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useArtcleCatList-loading-${cid}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useArtcleCatList-error-${cid}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const catListGet = async (customQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.ArtcleCatList(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value = null;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    load: catListGet,
    list: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
